import { useMemo } from 'react';

import { useObjectEditLayoutStore } from '../../store/objectEditLayoutStore';
import { useMainContentTabsShallow } from './useMainContentTabsShallow';

export function useIsObjectEditPageActive() {
  const { activeTab } = useMainContentTabsShallow();
  const inlineFindingEditId = useObjectEditLayoutStore(
    (state) => state.inlineFindingEditId,
  );

  return useMemo(() => {
    if (!activeTab) {
      return false;
    }

    if (activeTab.id.startsWith('finding-edit-')) {
      return true;
    }

    if (activeTab.type !== 'finding') {
      return false;
    }

    if (activeTab.data.mode === 'edit') {
      return true;
    }

    return (
      !!activeTab.data.findingId &&
      inlineFindingEditId === activeTab.data.findingId
    );
  }, [activeTab, inlineFindingEditId]);
}
